
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/doctor/application/claim",
      function () {
        return require("private-next-pages/doctor/application/claim.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/doctor/application/claim"])
      });
    }
  